<div sdIsCollapsible
  class="c__collapsible-container"
  [previewPanel]="text"
  [collapsiblePanel]="hide"
  (isOpenChange)="isOpen = !isOpen"
  [action]="action"
>
  <div #action #text class="c__header {{isOpen ? 'is-open' : ''}}">
    <p [class]="isMobile$ ? 'is-caption' : ''">
      <b>{{ comparedProducts.length }} / {{maxProducts}}
      {{(comparedProducts.length > 1 ? 'product.products' : 'product.product') | translate}}&nbsp;</b>
      {{'comparator.addedProducts' | translate}}
    </p>
    <sd-icon [name]="isOpen ? 'icon-arrow-up' : 'icon-arrow-down'" [size]="iconSize.small" />
  </div>

  <div class="c__body" #hide>
    <div class="c__product-container">
      @for (product of comparedProducts; track trackByProductCode($index, product)) {
        <div class="c__product">
          <sd-banner
            [media]="product.media"
            [isFit]="true"
            [hasBorder]="true"
            [imgRatio]="imageRatio.r4_3"
          />
          <button sd-button-icon
            icon="icon-trash"
            (click)="onDelete(product.code)"
            [buttonIconTitle]="('comparator.delete' | translate) + ' - ' + product.title"
            [size]="iconSize.small"
          ></button>
        </div>
      }

      @if (comparedProducts.length < maxProducts) {
        @for (emptyProduct of emptyProducts; track emptyProduct) {
          <div class="c__product is-placeholder is-4_3"></div>
        }
      }
    </div>

    <button sd-button
      [isSmall]="isMobile$"
      [disabled]="comparedProducts.length < 2"
      (click)="validateComparison()"
      class="c__validate-comparison"
    >
      {{ 'comparator.compare' | translate }}
    </button>
  </div>
</div>
